import { h } from 'vue'
import type { ColumnDef } from '@tanstack/vue-table'
import { ArrowUpDown, ChevronDown } from 'lucide-vue-next'
import { Button } from '@/components/ui/button'
import { format } from 'date-fns' 


export interface Collision {
  project: string;
  who: string;
  short: string;
  start: Date;
  end: Date;
}


export const colscollisions: ColumnDef<Collision>[] = [
  {
	key: 'project', label: "Projekt", type: "text"
  },
  {
    key: 'who', label: "Wer", type: "text"
  },
  {
    key: 'short', label: "Name", type: "text"
  },
  {
    key: 'start', label: "Anfang", type: "date"
  },
  {
	key: 'end', label: "Ende", type: "date"
  },
]